import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { getStyleGuide, updateStyleGuide } from '@/api/settings';
import { handleKnownSettingsApiErrors } from '@/stores/settings/errorHandling';

export const useSettingsGuides = defineStore('settingsGuides', () => {
  const loadingStore = useAppLoading();
  const { addErrorSnackbar } = useAppSnackbar();

  const guides = ref([]);

  const comingSoonFlagsOnGuideCategories = computed(
    () => [...guides.value].map((category) => {
      if (category.display_page?.includes('preview')) {
      // eslint-disable-next-line no-param-reassign
        category.comingSoon = true;
      }

      return category;
    }),
  );

  const styleGuideItems = computed(() => comingSoonFlagsOnGuideCategories.value.filter(
    (guide) => guide.display_page.includes('style_guide'),
  ));
  const policyGuideItems = computed(() => comingSoonFlagsOnGuideCategories.value.filter(
    (guide) => guide.display_page.includes('policy_guide'),
  ));

  const loadGuides = async () => {
    loadingStore.setLoading({ pageLoading: true });
    try {
      guides.value = await getStyleGuide();
    } catch (error) {
      const knownError = handleKnownSettingsApiErrors({ context: 'Unable to load Style Guides', error });

      if (knownError) return;

      addErrorSnackbar({
        text: `Unable to load Style Guides - ${error.message}`,
      });
      throw error;
    } finally {
      loadingStore.setLoading({ pageLoading: false });
    }
  };

  const submit = async (data) => {
    try {
      await updateStyleGuide(data);
    } catch (error) {
      const knownError = handleKnownSettingsApiErrors({ context: 'Unable to update Style Guide', error });

      if (knownError) return;

      addErrorSnackbar({
        text: `Unable to update Style Guide - ${error.message}`,
      });
      throw error;
    }
  };

  return {
    guides,
    styleGuideItems,
    policyGuideItems,
    loadGuides,
    submit,
  };
});
